<template>
  <v-autocomplete
      v-model="value"
      :items="values"
      item-text="name"
      item-value="id"
      :label="label"
      return-object
      hide-details
  />
</template>

<script>
import VueTypes from "vue-types";
import {FireflyKind} from "@/modules/redactor/models/firefly/FireflyKind";

export default {
  name: "r-firefly-kind",
  props: {
    model: VueTypes.instanceOf(FireflyKind),
    label: VueTypes.string.def("Firefly")
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    },
    values() {
      return FireflyKind.getValues();
    }
  }
}
</script>